export default __webpack_public_path__ + "static/media/JACKSON.8eaa7b3b.png";